import { Component, NgZone, OnInit } from '@angular/core';
import {  Router, RouterLink, RouterModule } from '@angular/router';
import { FormsModule, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { AccountService } from '../../services/account.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { SessionService } from '../../services/session.service';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { InputOtpModule } from 'primeng/inputotp';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';

@Component({
  selector: 'app-login-user',
  imports: [FormsModule, RouterLink, ReactiveFormsModule, NgxSpinnerModule, RouterModule,
    ToastrModule, CommonModule, InputTextModule, InputOtpModule, ButtonModule, PasswordModule,
  ],
  templateUrl: './login-user.html',
  styleUrl: './login-user.css'
})
export class LoginUser {

  public loginType: string = 'password';
  public showPassword: boolean = false;
  public inputType: string = '';
  togglePassword() {
    this.showPassword =! this.showPassword;
  }

  public loginForm: FormGroup;
  public loginOTPForm: FormGroup;
  public displayVersion: string = '1.0';  
  public displayYear: string = '';
  constructor(private fb: FormBuilder,
              private accountService: AccountService,
              private sessionService: SessionService,
              private router: Router,
              private ngZone: NgZone,
              private spinner: NgxSpinnerService,
              private toastr: ToastrService
  ){
    this.loginForm = this.fb.group({
      userId: new FormControl('', Validators.required),
      userPassword: new FormControl('', Validators.required)
    });
    this.loginOTPForm = this.fb.group({
      userId: new FormControl('', Validators.required),
      userToken: new FormControl('', Validators.required),
      userOTP: new FormControl('', Validators.required)
    });
    //this.displayVersion = packageJson.version;
    this.displayYear = new Date().getFullYear().toString();
  }

  ngOnInit(): void {
    // Initialize component
  }

  userLogin(frm: FormGroup): void {
    if (frm.valid) {
      const uname = frm.get('userId')?.value;
      const intype = this.detectInputType(uname);
      if (intype === 'unknown') {
        this.toastr.warning('Please enter a valid email or mobile number');
        return;
      }
      const upassword = frm.get('userPassword')?.value;
      const loginObj = {
        userId: uname,
        userPassword: upassword
      };
      this.spinner.show();
      this.accountService.loginUser(loginObj).subscribe((res: any) => {
        //  console.log(res);
         this.sessionService.setAccountId(res.data.accountId);
         this.sessionService.setAccessToken(res.data.authToken);
         this.sessionService.setFirstName(res.data.firstName);
         this.sessionService.setUsertype(res.data.userType);
         this.sessionService.setRefreshToken(res.data.refreshToken);
         const expirtyIn = res.data.tokenExpiry || 60;
         const curdate = new Date();
         curdate.setMinutes(curdate.getMinutes() + expirtyIn);
         const exptime = parseInt((curdate.getTime()/1000).toString())
         this.sessionService.setExpirtytime(exptime.toString());
         this.sessionService.setLoggedIn(true);
         if (res.data.userType === 'admin') {
          this.sessionService.setIsAdmin(true);
          this.router.navigate(['/app/dashboard']);
        } else {
          this.sessionService.setIsAdmin(false);
          this.router.navigate(['/app/profile']);
        }
         this.spinner.hide();
      }, (err: any) => {
        this.spinner.hide();
        this.toastr.error(err?.error?.message);
      });
    }
  }

  changeLoginType(changeType: string): void {
    if (changeType === 'otp') {
      const userid = this.loginForm.get('userId')?.value;
      if (userid === '' || userid === null || userid === undefined) {
        this.toastr.warning('Please enter a valid email or mobile number');
        return;
      }
      this.loginOTPForm.get('userId')?.setValue(this.loginForm.get('userId')?.value);
      this.loginOTPForm.get('userToken')?.setValue('');
      this.loginOTPForm.get('userOTP')?.setValue('');
      this.loginForm.get('userId')?.setValue('');
      this.loginForm.get('userPassword')?.setValue('');
      this.loginType = 'otp';
      this.spinner.show();
      const reqobj = {
        userId: this.loginOTPForm.get('userId')?.value,
        requestType: 'login'
      }
      this.accountService.requestCode(reqobj).subscribe((res: any) => {
        this.spinner.hide();
        if (res != null) {
          this.loginOTPForm.get('userToken')?.setValue(res.data.userToken);
        }
      }, (err: any) => {
        this.spinner.hide();
        this.toastr.warning(err?.error?.message);
      });
    } else if (changeType === 'password') {
      this.loginForm.get('userId')?.setValue(this.loginOTPForm.get('userId')?.value);
      this.loginForm.get('userPassword')?.setValue('');
      this.loginOTPForm.get('userId')?.setValue('');
      this.loginOTPForm.get('userToken')?.setValue('');
      this.loginOTPForm.get('userOTP')?.setValue('');
      this.loginType = 'password';
    }
    
  }

  userLoginWithOtp(frm: FormGroup): void {
    if (frm.valid) {
      const uname = frm.get('userId')?.value;
      const intype = this.detectInputType(uname);
      if (intype === 'unknown') {
        this.toastr.warning('Please enter a valid email or mobile number');
        return;
      }
      const loginObj = {
        userId: uname,
        userToken: frm.get('userToken')?.value,
        userOTP: frm.get('userOTP')?.value
      };
      this.spinner.show();
      this.accountService.loginUserWithOtp(loginObj).subscribe((res: any) => {
         this.sessionService.setAccountId(res.data.accountId);
         this.sessionService.setAccessToken(res.data.authToken);
         this.sessionService.setFirstName(res.data.firstName);
         this.sessionService.setUsertype(res.data.userType);
         this.sessionService.setRefreshToken(res.data.refreshToken);
         const expirtyIn = res.data.tokenExpiry || 60;
         const curdate = new Date();
         curdate.setMinutes(curdate.getMinutes() + expirtyIn);
         const exptime = parseInt((curdate.getTime()/1000).toString())
         this.sessionService.setExpirtytime(exptime.toString());
         this.sessionService.setLoggedIn(true);
         if (res.data.userType === 'admin') {
          this.sessionService.setIsAdmin(true);
          this.router.navigate(['/app/dashboard']);
          } else {
            this.sessionService.setIsAdmin(false);
            this.router.navigate(['/app/profile']);
          }
          this.spinner.hide();
      }, (err: any) => {
        this.spinner.hide();
        this.toastr.error(err?.error?.message);
      });
    }
  }


  detectInputType(input: string): any {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^\d{10}$/; // Assuming a 10-digit phone number format
    if (emailPattern.test(input)) {
      return 'email';
    } else if (phonePattern.test(input)) {
      return 'mobile';
    } else {
      return 'unknown';
    }
  }
}
